import React from 'react';
import { Modal, Button } from 'antd';
import './modal.scss';
import { useHistory } from 'react-router-dom';
import { deleteAboContent } from '../../../services/library/contents/contents.service';

const ModalContentRemove = (props) => {
  const {
    visibleModal,
    setVisibleModal,
    setVisibleModalRemoveSuccess,
    title,
    item,
    setLoading,
  } = props;
  const history = useHistory();

  const handleCancel = () => {
    setVisibleModal(false);
  };

  const confirmRemove = async () => {
    setVisibleModal(false);
    setLoading(true);
    await deleteAboContent(item);
    setLoading(false);
    setVisibleModalRemoveSuccess(true);
  };

  return (
    <Modal
      className="warp-modal"
      open={visibleModal}
      centered
      footer={null}
      onCancel={handleCancel}
      closable={true}
      maskClosable={false}
    >
      <div className="modal-image-icon">
        <img src="../../images/library/icon_confirm_delete_content.svg"></img>
      </div>
      <div className="modal-title">ต้องการลบ {title} เมนู ?</div>
      <div className="modal-desc">กรุณากดปุ่ม “ยืนยัน” เพื่อลบ Content นี้</div>
      <Button
        className="btn"
        onClick={() => {
          confirmRemove();
        }}
        block
      >
        ยืนยัน
      </Button>
      <Button
        type="link"
        className="link"
        onClick={() => {
          handleCancel();
        }}
        block
      >
        ยกเลิก
      </Button>
    </Modal>
  );
};
export default ModalContentRemove;
